import React from 'react';

interface MiniSparklineProps {
  positive?: boolean;
}

const MiniSparkline: React.FC<MiniSparklineProps> = ({ positive = true }) => {
  return (
    <svg width="60" height="24" className="opacity-50">
      <path
        d={positive ? 'M0,18 Q10,16 20,14 T40,10 T60,6' : 'M0,6 Q10,8 20,10 T40,14 T60,18'}
        fill="none"
        stroke={positive ? '#10B981' : '#EF4444'}
        strokeWidth="2"
      />
    </svg>
  );
};

export default MiniSparkline;
